import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
} from "reactstrap";

function NoteModal(props) {
  return (
    <Modal
      isOpen={props.noteModal}
      toggle={props.noteModaltoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props.noteModaltoggle}>
        Add Note
      </ModalHeader>
      <ModalBody>
        <Form className="formWrap">
          <div className="formElmWrap">
            <Input
              id=""
              name=""
              placeholder="Key note"
              type="textarea"
              rows={7}
            />
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.noteModaltoggle}>
          Save
        </Button>
        <Button color="outline" onClick={props.noteModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default NoteModal;
